// Static display strings for design options. Catalog data still loaded from /api/catalog.

export const NECK_LABELS = {
  round: "Round",
  v_neck: "V-Neck",
  sweetheart: "Sweetheart",
  boat: "Boat",
  halter: "Halter",
  collar: "Collar",
  square: "Square",
};

export const SLEEVE_LABELS = {
  full: "Full Sleeve",
  three_quarter: "3/4 Sleeve",
  half: "Half Sleeve",
  cap: "Cap Sleeve",
  sleeveless: "Sleeveless",
  bell: "Bell Sleeve",
  puff: "Puff Sleeve",
};

export const LENGTH_LABELS = {
  mini: "Mini",
  knee: "Knee",
  midi: "Midi",
  ankle: "Ankle",
  floor: "Floor Length",
};

export const COLOR_SWATCHES = [
  { hex: "#6B2737", name: "Rouge" },
  { hex: "#1F2D3D", name: "Midnight" },
  { hex: "#2E1A2B", name: "Aubergine" },
  { hex: "#0F3D2E", name: "Forest" },
  { hex: "#CFA05E", name: "Zari Gold" },
  { hex: "#D9C2A7", name: "Champagne" },
  { hex: "#7B2C3B", name: "Maroon" },
  { hex: "#1B1B1B", name: "Onyx" },
  { hex: "#E8DAC1", name: "Ivory" },
  { hex: "#A37C5B", name: "Bronze" },
  { hex: "#3B2E5A", name: "Indigo" },
  { hex: "#8E2D4A", name: "Berry" },
];

export const formatINR = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n || 0);
